import { configureStore, Action } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import rootReducer, { RootState } from './reducers/rootReducer';
import storage from 'redux-persist/lib/storage';
export const persistConfig = {
	key: 'root',
	version: 1,
	blacklist: ['common'],
	throttle: 5000,
	storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: true,
			immutableCheck: true,
			serializableCheck: false,
		}),
});

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export const persistor = persistStore(store);
export default store;
